<template>
    <div class="service-support-section">
        <v-container>
            <v-row align="center" justify="space-between">
                <!-- Left Content -->
                <v-col cols="12" md="6" class="mb-6 mb-md-0">
                    <div class="service-text-content">
                        <h2 class="service-title">
                            บริการครบวงจรเพื่อสนับสนุน<br />
                            งานออกแบบและก่อสร้าง
                        </h2>
                        <p class="service-description">
                            เราให้บริการตั้งแต่สำรวจพื้นที่ ถอดแบบ ประเมินราคา
                            ไปจนถึงยื่นขออนุญาตและบริหารงบประมาณเสริมด้วย
                            งานตกแต่งภายในและควบคุมความปลอดภัยและตรวจรับ
                            งานก่อนส่งมอบดูแลทุกขั้นตอนด้วยทีมงานมืออาชีพ
                            เพื่อความราบรื่นและแม่นยำของโครงการครบจบในที่
                            เดียว ประหยัดเวลา ควบคุมคุณภาพและลดความซับซ้อน
                            ในการก่อสร้าง
                        </p>
                    </div>
                </v-col>

                <!-- Right Image -->
                <v-col cols="12" md="6">
                    <div class="service-image-wrapper">
                        <v-img src="/aboutus/36926.jpg" alt="Service Support Building"
                            class="service-image rounded-lg" height="400" cover />
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    name: "ServiceSupport",
};
</script>

<style scoped>
.service-support-section {
    max-width: 1440px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 64px 0;
}

.service-text-content {
    padding-right: 24px;
}

.service-title {
    font-size: 36px;
    font-weight: 700;
    color: #1f2937;
    line-height: 1.25;
    margin-bottom: 24px;
}

.service-description {
    color: #4b5563;
    font-size: 18px;
    line-height: 1.625;
}

.service-image-wrapper {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
    .service-support-section {
        padding: 36px 0;
    }

    .service-text-content {
        padding-right: 0;
        margin-bottom: 16px;
    }

    .service-title {
        font-size: 22px;
        margin-bottom: 14px;
    }

    .service-description {
        font-size: 14px;
        line-height: 1.7;
    }
}
</style>
